// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bzfCKqPhinobVCeB4ZUW{flex-direction:column;gap:8px;padding:4px 0 24px;display:flex}.Jils0JeQwEm0h7uUT1y0{padding-bottom:32px}.gpOMBP38aqE4LtDryFSa{flex-wrap:wrap;justify-content:flex-start;align-items:center;gap:8px;padding:0 0 10px;display:flex}.uaVLp1ZDUpQ9kdTrEaeA{border:1px solid var(--border-neutral-default);background:var(--background-primary-inverted-primary);border-radius:6px;justify-content:space-between;gap:8px;width:-webkit-max-content;width:max-content;padding:4px 8px;display:flex}.SliRv2otdEEtQnBWLsah{height:40px;margin-top:24px}.A8Fv6mG9e502OiMBgDLx{color:#f22f46}.p8OIdtI2BAi25hQeO1cC{justify-content:space-between;align-items:center;margin-bottom:4px;display:flex}.qoICMy3KwPICHI78NRtP{margin-left:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `bzfCKqPhinobVCeB4ZUW`,
	"list": `Jils0JeQwEm0h7uUT1y0`,
	"items": `gpOMBP38aqE4LtDryFSa`,
	"item": `uaVLp1ZDUpQ9kdTrEaeA`,
	"addButton": `SliRv2otdEEtQnBWLsah`,
	"icon": `A8Fv6mG9e502OiMBgDLx`,
	"secondLine": `p8OIdtI2BAi25hQeO1cC`,
	"secondLineTooltip": `qoICMy3KwPICHI78NRtP`
};
export default ___CSS_LOADER_EXPORT___;
